import Cross from "../../../assets/icon/NewsIcons/MainAdmin/NewsCross"
import React, { useState, useEffect, useRef } from "react";
import { axiosReq } from "../../../commons/axiosReq";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Select from "react-select";
const AddModalCollegeField = ({ setShowModal, title, buttonName,
    setRecheck, reCheck, data, fields, id
    , setSettingModal, setData }) => {
    let navigate = useNavigate();
    const [snipper, setSnipper] = useState(false);
    const [showErrorModalStep1,
        setShowErrorModalStep1] = useState(false);
    const [error, setEroor] = useState();
    const [city, setCity] = useState([]);
    const colourStyles = {
        control: (defaultStyles, state) => ({
            ...defaultStyles, backgroundColor: 'white'
        }),
        option: (defaultStyles, { data, isDisabled, isFocused, isSelected }) => {
            return {
                ...defaultStyles,
                backgroundColor: isDisabled ? 'white' : 'white',


                color: '#000',
                cursor: isDisabled ? 'not-allowed' : 'default',

            };
        },

    };
    const [allValues, setAllValues] = useState({
        FieldId: data ? data.fieldId : '',
    });
    const [allValuesError, setAllValuesError] = useState({
        FieldId: false,
    });
    const blurHandler = e => {
        if (e.target) {
            if (e.target.value == "") {

                setAllValuesError({ ...allValuesError, [e.target.name]: true })
            }


        }

    }
    const changeHandler = e => {
        if (e.target) {
            if (e.target.value != "") {

                setAllValuesError({ ...allValuesError, [e.target.name]: false })
            }
            else {
                setAllValuesError({ ...allValuesError, [e.target.name]: true })

            }
            // setAllValuesError({ ...allValuesError, [""]: false })


            setAllValues({ ...allValues, [e.target.name]: e.target.value })
        }
    }
    const handleKeyDown = (e) => {
        if (e.code === "Enter") {
            addAdmin();
        }
    };
    const changeHandlerSelect = (e, name) => {
        if (e.value != "") {

            setAllValuesError({ ...allValuesError, [name]: false })
        }
        else {
            setAllValuesError({ ...allValuesError, [name]: true })

        }
        // setAllValuesError({ ...allValuesError, [""]: false })

        setAllValues({ ...allValues, [name]: e.value })

    }

    const addAdmin = async () => {

        setSnipper(true)


        var res = allFull(allValues)
        console.log(res)
        if (res) {
            const dataUser = await axiosReq("CollegeField/InsertCollegeField", "post", {
                CollegeId: id,
                FieldId: allValues.FieldId

            });
            console.log(dataUser)
            if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
                setRecheck(!reCheck)
                setShowModal(false)
                setData(dataUser?.data)
                // setSettingModal(true)
                //   navigate("/newRequestStep2/" + dataUser?.data?.requestId)
                alert("موفقیت آمیز");

            }
            else {
                console.log(allValuesError)
                setEroor(dataUser?.data)

                setShowErrorModalStep1(true);
            }
        }
        else {
            setEroor("لطفا موارد خواسته شده را وارد نمایید")

            console.log(allValuesError)
            setShowErrorModalStep1(true);

        }

    }
    const editAdmin = async () => {

        setSnipper(true)



        setSnipper(true)
        var res = allFull(allValues)
        console.log(res)
        if (res) {
            const dataUser = await axiosReq("CollegeField/UpdateCollegeField", "put", {
                CollegeFieldId: data?.id,
                CollegeId: id,
                FieldId: allValues.FieldId

            });
            console.log(dataUser)
            if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
                setRecheck(!reCheck)

                //   navigate("/newRequestStep2/" + dataUser?.data?.requestId)
                alert("موفقیت آمیز");
                setShowModal(false)
            }
            else {
                console.log(allValuesError)
                setEroor(dataUser.data);

                setShowErrorModalStep1(true);
            }
        }
        else {
            setEroor("لطفا موارد خواسته شده را وارد نمایید")

            console.log(allValuesError)
            setShowErrorModalStep1(true);

        }
    }
    const allFull = (obj) => {
        const updatedState = {};
        var result = true;
        for (var o in obj) {
            if (obj[o] == "" && o != "IsAdmin") {
                updatedState[o] = true;


                setAllValuesError({ ...allValuesError, ...updatedState })
                result = false;
            }
        

        }
        console.log(allValuesError)
        return result
    }

   



    return (
        <>
            <div
                className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
            >
                <div className="relative w-[50%] my-5 mx-auto ">

                    <div className="border-0 rounded-[20px] p-[25px] shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <div className="flex justify-between items-center border-b-2 pb-[25px] border-borderGray">
                            <p className="text-[15px] font-IRANYekanBold text-mainColor2">{title}</p>
                            <button onClick={() => setShowModal(false)}><Cross /></button>
                        </div>
                        <div className="grid grid-cols-2 gap-2 w-full mt-[23px] mb-[43px]">



                            <div className="flex flex-col w-[80%] xl-1400:w-[28%] xl-1400:ml-[2%] xl-1400:mr-0 xl-lg:w-[100%] xl-lg:mx-0 ml-[1.5%] mb-7">
                                <span className="text-base font-bold font-IRsans">رشته </span>
                                <div class="mt-2" id="FightPathdiv">
                                    <Select
                                        options={fields}
                                        placeholder="انتخاب کنید"
                                        // value={selectedOptions}
                                        id="FieldId"
                                        name="FieldId"
                                        onChange={(e) => changeHandlerSelect(e, "FieldId")}
                                        styles={colourStyles}
                                        class={`font-IRsans text-right right-6 bg-white ${allValuesError.CityId ? "border-[#ff0000]" : "border-gray-300"} border border-gray-300 text-gray-900 text-sm rounded-md  block w-full p-2.5`}
                                        // onChange={handleSelect}
                                        isSearchable={true}
                                    />

                                    {/* <input   
              type="text"
              id="FlightPath"
              name="FlightPath"
              onChange={changeHandler}
              onBlur={blurHandler}
              class={`font-IRsans text-right right-6 bg-white border ${allValuesError.FlightPath?"border-[#ff0000]":"border-gray-300"} text-gray-900 text-sm rounded-md  focus:ring-mainColor focus:border-mainColor block w-full p-2.5`}
              placeholder="مسیر پرواز" /> */}
                                </div>
                                {/* <p className={`text-[#ff0000] tracking-wide mt-1  text-xs font-[10px] font-IRsans ${allValuesError.CityId ? "flex" : "hidden"}`}>لطفا یک مورد را انتخاب نمایید!</p> */}


                            </div>
                        </div>
                        <div className="flex justify-center">
                            <button onClick={() => setShowModal(false)}><p className="text-[15px] font-IRANYekanBold ml-[23px]">بستن</p></button>
                            <button onClick={() => title == "ویرایش" ? editAdmin() : addAdmin()} className="h-[40px] w-[107px] bg-infinity-gradient rounded-[10px]"><p className="text-[15px] text-white font-IRANYekanBold">{buttonName}</p></button>
                        </div>
                    </div>
                </div>
                {showErrorModalStep1 ?
                    <>
                        <div
                            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                        >
                            <div className="relative w-[50%] lg:w-[50%] sm:w-[95%] my-5 mx-auto max-w-3xl">

                                <div className="border-0 rounded-lg p-2 shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">

                                    <div className="flex items-start justify-between p-4 border-b border-solid border-b-midGray rounded-t">
                                        <span className="text-base font-bold   text-red">
                                            درخواست اشتباه !
                                        </span>

                                    </div>

                                    <div className="relative px-4 py-1 flex-auto">
                                        <p className="my-4 text-black text-sm   leading-relaxed">
                                            {error}
                                        </p>
                                    </div>

                                    <div className="flex  items-center  justify-end border-solid border-slate-200 rounded-b">
                                        <Link

                                            className="text-white  mx-4 mb-2  rounded-md shadow-blueShadow  bg-infinity-gradient font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={() => setShowErrorModalStep1(false)}
                                        >
                                            فهمیدم
                                        </Link>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>

                    </>
                    : null
                }
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
    )
}

export default AddModalCollegeField;